import i18n from '@/plugins/i18n';
import { stubTrue } from 'lodash';
export const forms = [
    {
        type: 'text',
        name: 'title',
        title: i18n.t('account.note.title'),
        rules: {required: true},
        modal: ['Title'],
        data: ['title'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'select',
        name: 'type',
        title: i18n.t('account.note.type'),
        rules: {required: true},
        options: {
            type: 'locale',
            data: [
                {id: 0, name:  i18n.t('account.note.all')},
                {id: 1, name:  i18n.t('account.note.trafficList')},
                {id: 2, name:  i18n.t('account.note.account')},
            ],
            label: 'name',
            track: 'id'
        },
        modal: ['apear_type'],
        data: ['apear_type',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'date',
        name: 'beginDate',
        title: i18n.t('account.note.beginDate'),
        format:'YYYY-MM-DDT00:00:00.000Z',
        rules: {},
        modal: ['begin_date'],
        data: ['begin_date'],
        nextField: 'endDate',
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'date',
        name: 'endDate',
        title: i18n.t('account.note.endDate'),
        format:'YYYY-MM-DDT00:00:00.000Z',
        rules: {},
        modal: ['end_date'],
        data: ['end_date'],
        additionalButton: false,
        checkBox: false
    },
   
    {
        type: 'radio',
        name: 'state',
        title: i18n.t('account.note.state'),
        rules: {required: true},
        options: {
            type: 'locale',
            data: [
                {text: i18n.t('account.note.passife'), value: false},
                {text: i18n.t('account.note.active'), value: true},
            ],
        },
        modal: ['is_active'],
        data: ['is_active'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'editor',
        name: 'desc',
        title: '',
        rules: {},
        modal: ['description'],
        data: ['description'],
        additionalButton: false,
        checkBox: false
    },
 
]
export default forms;


// WEBPACK FOOTER //
// ./src/pages/Alarmsis/Account/forms/Note.js